var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 0C4.47598 0 0.000976562 4.475 0.000976562 10C0.000976562 14.425 2.86348 18.1625 6.83848 19.4875C7.33848 19.575 7.52598 19.275 7.52598 19.0125C7.52598 18.775 7.51348 17.9875 7.51348 17.15C5.00098 17.6125 4.35098 16.5375 4.15098 15.975C4.03848 15.6875 3.55098 14.8 3.12598 14.5625C2.77598 14.375 2.27598 13.9125 3.11348 13.9C3.90098 13.8875 4.46348 14.625 4.65098 14.925C5.55098 16.4375 6.98848 16.0125 7.56348 15.75C7.65098 15.1 7.91348 14.6625 8.201 14.4125C5.97598 14.1625 3.65098 13.3 3.65098 9.475C3.65098 8.3875 4.03848 7.4875 4.67598 6.7875C4.57598 6.5375 4.22598 5.5125 4.77598 4.1375C4.77598 4.1375 5.61348 3.875 7.52598 5.1625C8.326 4.9375 9.176 4.825 10.026 4.825C10.876 4.825 11.726 4.9375 12.526 5.1625C14.4385 3.8625 15.276 4.1375 15.276 4.1375C15.826 5.5125 15.476 6.5375 15.376 6.7875C16.0135 7.4875 16.401 8.375 16.401 9.475C16.401 13.3125 14.0635 14.1625 11.8385 14.4125C12.201 14.725 12.5135 15.325 12.5135 16.2625C12.5135 17.6 12.501 18.675 12.501 19.0125C12.501 19.275 12.6885 19.5875 13.1885 19.4875C17.259 18.1133 19.9999 14.2963 20.001 10C20.001 4.475 15.526 0 10.001 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a033adc8c119227be247e4fa4ef4b268.svg";
export { ForwardRef as ReactComponent };